import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./MemberLimit.module.scss";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Button, Collapse, IconButton, TextField } from "@mui/material";
import { v4 } from "uuid";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import * as YStyled from '../../../Styleds';
const MemberLimit = ({ data, set_data }) => {
    const [memberCheckBox, set_memberCheckBox] = useState(false);
    useEffect(() => {
        if (data.events_participant_limit > 0)
            set_memberCheckBox(true);
    }, [])
    return (
        <div className={style.memberPanel}>
            <div className={style.title}>
                <YStyled.Span size={17} style={{ paddingRight: ".6rem" }}>人數上限</YStyled.Span>
                {memberCheckBox ?
                    <CheckBoxIcon sx={{ color: '#3149CE' }} onClick={e => {
                        set_memberCheckBox(false);
                        set_data(prev => { return { ...prev, events_participant_limit: 0 } })
                    }} />
                    :
                    <CheckBoxOutlineBlankIcon sx={{ color: '#3149CE' }} onClick={e => {
                        set_memberCheckBox(true);
                        //set_data(prev => { return { ...prev, events_participant_limit: 1 } })
                    }} />
                }

            </div>

            {
                memberCheckBox &&
                <div className={style.numberCtrl}>
                    <IconButton disabled={!memberCheckBox} onClick={e => {
                        set_data(prev => { return { ...prev, events_participant_limit: prev.events_participant_limit > 1 ? prev.events_participant_limit -= 1 : 1 } })
                    }}>
                        <RemoveIcon />
                    </IconButton>
                    <div><span>{data.events_participant_limit}</span></div>
                    <IconButton disabled={!memberCheckBox} onClick={e => {
                        set_data(prev => { return { ...prev, events_participant_limit: prev.events_participant_limit += 1 } })
                    }}>
                        <AddIcon />
                    </IconButton>
                </div>
            }

        </div>
    );
}

export default MemberLimit;